import { Auth } from "common";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { YStack, Text, Spinner, Button } from "tamagui";

const OAuthCallback = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleAuth = async () => {
      try {
        const session = await Auth.currentSession();
        const idTokenClaims = session.tokens?.idToken?.payload;

        if (!idTokenClaims) {
          throw new Error("ID Token is missing");
        }

        navigate("/");
      } catch (err) {
        console.error("Error fetching user", err);
        setError("Failed to retrieve user details. Please try again.");
      }
    };

    handleAuth();
  }, [navigate]);

  if (error) {
    return (
      <YStack flex={1} alignItems="center" justifyContent="center" padding="$4">
        <Text color="$red10">{error}</Text>
        <Button marginTop="$4" onPress={() => navigate("/login")}>
          {t("auth.backToLogin")}
        </Button>
      </YStack>
    );
  }

  return (
    <YStack flex={1} alignItems="center" justifyContent="center" padding="$4">
      <Spinner size="large" color="$blue10" />
      <Text marginTop="$4">{t("common.loading")}</Text>
    </YStack>
  );
};

export default OAuthCallback;
